import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@/components/ui/form"
import { Control, useFormContext } from "react-hook-form"
import { FormLabelWithIndicator } from "../form-label-with-indicator"
import { DatePicker } from "@/components/ui/date-picker"
import { CustomFieldProps } from '../custom-fields-container';
import { useCallback } from "react";

type CustomDateFieldProps = CustomFieldProps & {
}


export function CustomDateField({
  control,
  name,
  label,
  description,
  showDescription,
  info,
  required,
  placeholder,
  isValid,
  showFormMessage,
}: CustomDateFieldProps) {

  const { trigger, setValue } = useFormContext();

  const handleOnChange = useCallback((value: any) => {
    console.debug('handleOnChange', name, value);
    setValue(name, value, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
    trigger();
  }, [setValue, trigger, name]);

  
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col">
          <FormLabelWithIndicator label={label} isValid={isValid} required={required} info={info} />
          <FormControl>
            <DatePicker
              date={field.value}
              ref={field.ref}
              setDate={handleOnChange}
              placeholder={placeholder}
            />
          </FormControl>
          {showDescription && (<FormDescription>{description}</FormDescription>)}
          {showFormMessage && <FormMessage />}  
        </FormItem>
      )}
    />
  )
}

